module.exports = __webpack_public_path__ + "img/bjx_detail_car_02.9231e592.png";